export const IFRAME_HOST = 'HOST';
export const MSG_TYPE_SYNC = 'SYNC';
export const MSG_TYPE_SYNC_ACK = 'SYNC_ACK';
export const MSG_TYPE_READY = 'READY';
export const MSG_TYPE_EMBEDDED_PROPS_CHANGED = 'EMBEDDED_PROPS_CHANGED';